/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Chip from '@mui/material/Chip';

import ClipListTitle from './ClipListTitle';
import ClipList from './ClipList';
import ClipListButtons from './ClipListButtons';
import { secondsToString } from '../../utils/timeStringFormat';
import { selectDurationOfSelectedClips } from '../../state/clipList';

const ClipListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 15px;
`;

const ClipListHeader = styled.div`
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-context: space-between;
`;

function ClipListPanel(props) {
  const { duration } = props;
  const durationString = secondsToString(duration);
  const durationLabel = `Selected Duration: ${durationString}`;

  // NOTE: use react-router native prompt component for now, to be iterated
  return (
    <ClipListContainer id="ClipListPane">
      <div>
        <Chip label={durationLabel} variant="outlined" />
      </div>
      <ClipListHeader>
        <ClipListTitle />
        <ClipListButtons />
      </ClipListHeader>
      <ClipList />
    </ClipListContainer>
  );
}

ClipListPanel.propTypes = {
  duration: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  duration: selectDurationOfSelectedClips(state),
});

export default connect(
  mapStateToProps,
  null,
)(ClipListPanel);
